import React, { Component } from 'react';
import styled, { withTheme } from 'styled-components';
import CollectionSubMenuTitle from './CollectionSubMenuTitle';
import ThronModal from "./ThronModal";
import TrainingManuals from '../icons/TrainingManuals';
import __ from '../utils/translator';
import ChevronRight from '../icons/ChevronRight';
import RenderOnMobile from './responsive/RenderOnMobile';
import RenderOnTablet from './responsive/RenderOnTablet';
import ManualStoreActions from "../flux/ManualStoreActions";
import PDFModal from "./PDFModal";

class CollectionSubMenuManuals extends Component{
  state = {
    thronModalOpened: false,
    manualAssetClicked: null,
  };

  onMediaClick = manual => {
    this.setState({
      thronModalOpened: true,
      manualAssetClicked: manual,
    });
  };

  onThronModalCloseButtonClick = () => {
    this.setState({ thronModalOpened: false, manualAssetClicked: null});
  };

  render() {
    return (
      <React.Fragment>
        <RenderOnMobile>
          <div style={{
            padding: '1rem',
          }}>
            {this.props.manuals.map(manual => (
              <ManualItem key={manual.id} onClick={() => this.onMediaClick(manual)}>
                <span>{manual.name}</span>
                <ChevronRight />
              </ManualItem>
            ))}
          </div>
        </RenderOnMobile>

        <RenderOnTablet>
          <CollectionSubMenuTitle>
            <TrainingManuals style={{ height: '2.5rem', marginRight: '1rem', }} />
            <span style={{ textTransform: 'uppercase', }}>{__('Merchandising Manuals')}</span>
          </CollectionSubMenuTitle>

          <Container>
            {this.props.manuals.map(manual => (
              <ManualCard key={manual.id} onClick={() => this.onMediaClick(manual)}>
                {manual.name}
              </ManualCard>
            ))}
          </Container>
        </RenderOnTablet>

        {this.state.thronModalOpened && (
          <PDFModal
            asset={this.state.manualAssetClicked}
            onCloseButtonClick={this.onThronModalCloseButtonClick}
            onPdfLoad={() => {
              ManualStoreActions.manualLoad(this.state.manualAssetClicked.id, this.state.manualAssetClicked.collectionId)
            }}
          />
        )}
      </React.Fragment>
    )
  }
}

export default withTheme(CollectionSubMenuManuals);

const Container = styled.div`
  display: flex;
  margin-left: .875rem;
  flex-wrap: nowrap;
  overflow-x: auto;
  transform: translateZ(0); // https://stackoverflow.com/a/30533339
  -webkit-overflow-scrolling: touch;
`;

const ManualCard = styled.button`
  display: flex;
  flex-shrink: 0;
  align-items: center;
  margin-bottom: 1rem;
  margin-top: 1rem;
  margin-right: 1.375rem;
  padding: .875rem;
  background-color: #fff;
  color: #565656;
  cursor: pointer;
`;

const ManualItem = styled.div `
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: .75rem 1.125rem;
  background-color: #000;
  border-bottom: .0625rem solid #fff;
  color: #fff;
  font-weight: bold;
  font-size: .875rem;

  > svg {
    height: 1rem;
  }
`;
